export default __webpack_public_path__ + "static/media/photostrip.dcf731f1.svg";